import React, { useState } from "react";
import styles from "./EventCardChecker.module.css";
import SkeletonEvents from "../Skeletons/SkeletonEvents"; 
import { formatDatSemiShort } from "../../helpers/dates";

const EventCardChecker = ({ id, image, onHandleClick, title, startDate, locale, loading }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const handleLoadImage = () => {
    setImageLoaded(true);
  };

  return (
    <div onClick={onHandleClick} className={styles.containerCardEvents}>
      {!imageLoaded && <SkeletonEvents />}

      <img
        className={`${!imageLoaded ? "d-none" : styles.imgEvents}`}
        src={image}
        alt="Event"
        onLoad={handleLoadImage}
        style={{
          height: "146px",
          width: "150px",
          objectFit: "cover",
          borderRadius: "8px",
        }}
      />

      {title && <div className={styles.titleEvent}>{title}</div>}
      {startDate && (
        <div className={styles.datesEvents}>
          {formatDatSemiShort(startDate, locale)}
        </div>
      )}
    </div>
  );
};

export default EventCardChecker;
